// Auth Data Transfer Objects (DTOs)
// Extracted from src/modules/auth/infra/dtos.ts to break cross-module dependencies

import { UserIdentifierType } from '@fuul/sdk';

import type { GetAffiliateCodeItemBasic } from './affiliates-dtos';

export type AffiliateCodeBasicItem = GetAffiliateCodeItemBasic;

export enum UserRole {
  User = 'user',
  FuulAdmin = 'admin',
}

export interface UserCredentialDTO {
  provider: string;
  provider_user_id: string;
  provider_username: string;
}

export interface UserDTO {
  id: string;
  address: string;
  email: string | null;
  twitter_username: string | null;
  github_username: string | null;
  discord_username: string | null;
  accepted_terms: boolean;
  role: UserRole;
  credentials?: UserCredentialDTO[];
}

export interface GetUserResponse {
  id: string;
  address: string;
  email: string;
  github_username?: string | null;
  twitter_username?: string | null;
  discord_username?: string | null;
  telegram_username?: string | null;
  accepted_terms: boolean;
  projects: GetUserResponseProject[];
  user_profile_image_url?: string | null;
  role: UserRole;
  affiliate?: AffiliateResponse | null;
}

export interface AffiliateResponse {
  id: string;
  name: string;
  user_identifier: string;
  user_identifier_type: UserIdentifierType;
  updated_at: string;
  codes: AffiliateCodeBasicItem[];
}

interface GetUserResponseProject {
  id: string;
  name: string;
}

export interface WalletSigninDTO {
  user_identifier: string;
  user_identifier_type: string;
  signature: string;
  message: string;
}

export interface FuulAuthSigninResponse {
  user: UserDTO;
  access_token: string;
  refresh_token: string;
}
